import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class PostService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('posts/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('posts/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('posts/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('posts/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('posts/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('posts/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('posts/delete', val_id);
  }
}
